import { render, staticRenderFns } from "./Toggle.vue?vue&type=template&id=2c1c1d22&"
import script from "./Toggle.vue?vue&type=script&lang=js&"
export * from "./Toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports